import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "title"
};
const _hoisted_2 = {
  class: "pc_content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_TinymceEditor = _resolveComponent("TinymceEditor");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_row, {
    class: "title_box1 m-b-10"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 24
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.data.title), 1)]),
      _: 1
    })]),
    _: 1
  }), _createElementVNode("div", _hoisted_2, [(_openBlock(), _createBlock(_component_TinymceEditor, {
    id: _ctx.data.id,
    ref: "editor",
    height: _ctx.data.height,
    "cur-value": _ctx.data.details,
    onInput: _ctx.inputContent,
    key: _ctx.data.key
  }, null, 8, ["id", "height", "cur-value", "onInput"]))])]);
}